import { QueryFactory } from "../../../../Common";
export const QUpdatePurchases = QueryFactory("UpdatePurchases");
//# sourceMappingURL=QUpdatePurchases.js.map